var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":_vm.title,"button-size":"sm","size":"lg","hide-footer":"","ok-title":"Luk","ok-only":"","no-stacking":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }